import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1331%3A8104&mode=dev)
 * */

const DeclineFillIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="#EC475C" fillRule="evenodd" d="M0 6a6 6 0 1012 0A6 6 0 000 6zm8.354-2.354a.5.5 0 010 .708L6.707 6l1.647 1.646a.5.5 0 11-.708.708L6 6.707 4.354 8.354a.5.5 0 11-.708-.708L5.293 6 3.646 4.354a.5.5 0 11.708-.708L6 5.293l1.646-1.647a.5.5 0 01.708 0z" clipRule="evenodd" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default DeclineFillIcon;